/**
 * Returns true if the event target is an input or textarea.
 */
export default function isUserTyping(event) {
  return (
    event.type.includes('key') &&
    ['input', 'textarea'].includes(event.target.tagName.toLowerCase())
  );
}
